import React, { useState } from 'react';
import {
  ThirdwebProvider,
  ConnectWallet,
  useWallet,
  metamaskWallet,
  coinbaseWallet,
  useConnectionStatus,
  useSigner,
  walletConnect,
  trustWallet,
  useAddress,
} from "@thirdweb-dev/react";
import { ethers } from 'ethers';
import ABI from './ABI.json'; // Path to your ABI file
import './App.css'
import logo from './logo.png'
import { MerkleTree } from 'merkletreejs';
import keccak256 from 'keccak256';


const contractAddress = "0x91f34191d65F4a2a80253D73eE29F878Cb868658"; // Replace with your contract's address

export default function App() {
  return (
    <ThirdwebProvider
      activeChain="ethereum"
      clientId="718204791854dbe64812896c871f7363"
      supportedWallets={[
        metamaskWallet(),
        coinbaseWallet({ recommended: true }),
        walletConnect(),
        trustWallet(),
      ]}
    >
    <div className='app'>
      <div className='app-header'>
        <a><img className='logo' src={logo} alt='logo'></img></a>
        <ConnectWallet style={{backgroundColor:'#ffcc00', color:'#000000', fontWeight:'700'}}/>
      </div>
      <MintNFTButton />
      
    
    </div>
     
    </ThirdwebProvider>
  );
}

function MintNFTButton() {
  const wallet = useAddress();
  const signer = useSigner();
  const connectionStatus = useConnectionStatus();
  const [success, setSuccess] = useState(false);
  const [mintAmount, setMintAmount] = useState(1); 

   // Function to decrease mintAmount
   const decreaseMintAmount = () => {
    setMintAmount(prev => prev > 1 ? prev - 1 : 1); // Ensure mintAmount does not go below 1
  };

  // Function to increase mintAmount
// Function to increase mintAmount with a maximum limit of 2
const increaseMintAmount = () => {
  setMintAmount(prev => prev < 5 ? prev + 1 : 5); // Ensure mintAmount does not go above 2
};



const whitelistAddresses = [
  '0x0A834DDe9360169F187d2128C80d9A244231C37d',
  '0x0b0DcBd3eaD7B44E4f93047273275f2c7274DbC1',
  '0x169852497F3cceDC580da77C42811df6Aa4CBeF9',
  '0x1CfD999a3929D6223BD894C8C24b2B2a31539740',
  '0x1ECDCd9F52959698c927a94D3F14d999f4202601',
  '0x23c0cdf4BD71ce6Bf44aCeeaD2F6941E17f29793',
  '0x298933E3a2151661791d6a4D64b9Fa2B374C669c',
  '0x2d0FBa2b273cb2B5fD8DAa83b820eE1F507A9df6',
  '0x2f42Ee40E728bBc8EF19D8B376B426B4F7829C0a',
  '0x45284685bC05111322d05E7b07117637E0323852',
  '0x5f5ce410d233bee8e46b05e465b293c92a0e9f3a',
  '0x6a8DCE699202FdaCA2f1Ae33b4AA456D77efBc06',
  '0x70D78902Fa83187cB454a9A0D86076Ea7aA38199',
  '0x9D6329f389a7E6230F91dc4BcD222FD1d261A068',
  '0xA5042C4f519F19E89c223E6e3AC5ac0BF4c15e6b',
  '0xB3330e8e2206983F4cB8a3c4Ef301eC2e8bFB370',
  '0xB53dC53DeEc5749B07A812CB935A8EC41Eb577A7',
  '0xc96dbf3Cd07369cB23DD362e3A7475f1158cd57d',
  '0xcD65951deBf5654D4A32143a6a3826C26DEc3519',
  '0xD1680075850A2EE58d4FE03c562b10a09152F254',
  '0xD4F4fc2b4B4e28cD1B9859a648DCb0822AFA26D4',
  '0xDDb5f4A172AA37f90726aE853C834Fc9c9863aab',
  '0xE13D341348aDB6cE5364A9A54C9ED4fdf06Ebc54',
  '0xD544884544C4c828921cA33d79E45504d574CB12'
];






const mintNFT = async () => {
  const leaves = whitelistAddresses.map(addr => keccak256(ethers.utils.getAddress(addr)));
  const tree = new MerkleTree(leaves, keccak256, { sortPairs: true });
  const leaf = keccak256(ethers.utils.getAddress(wallet));
  const proof = tree.getHexProof(leaf);

  const isWalletWhitelisted = whitelistAddresses.map(addr => ethers.utils.getAddress(addr)).includes(ethers.utils.getAddress(wallet));
  const root = tree.getHexRoot(); // Calculate the Merkle root

  console.log(wallet)
  console.log(isWalletWhitelisted)

  



  console.log(proof)
  console.log(root)
  console.log(wallet)

  if (connectionStatus === "connecting") {
    console.log("Please connect your wallet");
    return;
  }

  try {
    const contract = new ethers.Contract(contractAddress, ABI, signer);

    // Calculate the total price for the mintAmount
    const pricePerNFT = ethers.utils.parseEther("0.059"); // Parse 0.049 ETH to Wei
    const totalPrice = pricePerNFT.mul(mintAmount); // Total price is price per NFT multiplied by mintAmount

    const transactionOverrides = {
      
      value: totalPrice, // This line sends the ETH along with the transaction
    };

    const tx = await contract.publicMint(mintAmount, transactionOverrides);
    const receipt = await tx.wait();
    console.log("NFT minted successfully!", receipt);
    setSuccess(true);

  } catch (error) {
    console.error("Minting failed:", error);
  }
};


  return (
    <div className='main'>
      <h1>It's time to mint your RoboMetaMorphs</h1>
      <div>
        <span className='mint-amount'>{mintAmount}</span> {/* Display current mint amount */}
         </div>
      {success ? <a href='https://opensea.io/collection/robometamorphs-1'><button className='mint-button' onClick={mintNFT} >Check on Opensea</button></a> : <div> <button className='decrement-button' onClick={decreaseMintAmount}>-</button> {/* Decrease mint amount */}
       <button className='mint-button' onClick={mintNFT} >Mint NFT</button> <button className='increment-button' onClick={increaseMintAmount}>+</button> {/* Increase mint amount */}
    </div>}
    </div>
  );
}
